import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/core/endpointsAndGeneric-constants/api-constants';
import { HttpMethodModifierService } from 'src/app/core/http-method-modifier.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private httpGuard: HttpMethodModifierService
  ) { }

  login(username: string, password: string) {
    const payload = {
      username: username,
      password: password
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT_V1', ApiConstants.URL.login, payload);
  }
}
